<template>
  <div class="empty">
    <div class="top">
      <i class="icon icon-authTip"></i>
      <div class="tips">
        <div class="tip1">{{ tip1 }}</div>
        <div class="tip2">{{ tip2 }}</div>
      </div>
    </div>
    <div class="bottom">
      <div class="tip3">{{ tip3 }}</div>
      <div class="tip4">{{ tip4 }}</div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tip1: "方正智+AI服务",
      tip2:
        "随着智能技术的发展，AI应用在媒体业务中的占比逐渐升高，为提供高效便捷的策采编发业务流程和应用能力，满足业务场景智能化的需求，方正电子融合大规模智能能力构建“方正AI中台”，不仅提供业务匹配的文字、语音、图片、视频等AI技术支持，同时结合业务场景，提供智能生产、智能策划、智能风控、智能认证、智能写作、虚拟智能等业务创新融合能力。方正AI，深度浸入业务场景，全面提升媒体智能化能力。",
      tip3: "暂未开通",
      tip4: "了解更多AI服务信息，请联系我们！"
    }
  }
}
</script>

<style lang="scss" scoped>
.empty {
  font-size: 14px;
  .top {
    display: flex;
    background-color: rgba(0, 112, 204, 0.05);
    i {
      flex-shrink: 0;
      margin: 10px 20px;
    }
    .tips {
      padding: 15px 15px 15px 0;
      .tip1 {
        font-size: 16px;
        margin-bottom: 10px;
      }
      .tip2 {
        line-height: 2;
      }
    }
  }
  .bottom {
    margin-top: 80px;
    color: #7f7f7f;
    text-align: center;
    .tip3 {
      font-size: 22px;
      font-weight: 600;
      margin-bottom: 20px;
    }
    .tip4 {
      font-size: 18px;
    }
  }
}
</style>
